/**
 * @generated SignedSource<<1c34e2708e8c38b4051b0bdc92ef40c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pantoneLibraryPage_colors$data = {
  readonly paletteColors: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly cmykHexCode: string | null;
        readonly colorID: number;
        readonly id: string;
        readonly name: string;
        readonly rgbHexCode: string;
        readonly spotColorName: string | null;
      };
    }> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
  readonly " $fragmentType": "pantoneLibraryPage_colors";
};
export type pantoneLibraryPage_colors$key = {
  readonly " $data"?: pantoneLibraryPage_colors$data;
  readonly " $fragmentSpreads": FragmentRefs<"pantoneLibraryPage_colors">;
};

import pantoneLibraryPageColorsQuery_graphql from './pantoneLibraryPageColorsQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "paletteColors"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "1",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 70,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "onlyDefaultColors"
    },
    {
      "defaultValue": "DESC",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "paletteTypeID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "useConversionTable"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": pantoneLibraryPageColorsQuery_graphql
    }
  },
  "name": "pantoneLibraryPage_colors",
  "selections": [
    {
      "alias": "paletteColors",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        },
        {
          "kind": "Variable",
          "name": "onlyDefaultColors",
          "variableName": "onlyDefaultColors"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "paletteTypeID",
          "variableName": "paletteTypeID"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "useConversionTable",
          "variableName": "useConversionTable"
        }
      ],
      "concreteType": "PaletteColorsConnection",
      "kind": "LinkedField",
      "name": "__pantoneColorsQuery_paletteColors_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PaletteColorsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PaletteColor",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "colorID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rgbHexCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cmykHexCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "spotColorName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "ab92584c06144feb1a9d087ea12d9473";

export default node;
